export default __webpack_public_path__ + "static/media/marc.2cfe483e.png";